import * as z from 'zod';
export const SpoilRowSchema = z.object({
    participantId: z.uuidv7(),
    isCorrect: z.boolean(),
    isWinner: z.boolean(),
});
//# sourceMappingURL=spoil.js.map